import {
  Card,
  CardBody,
  CardFooter,
  Stack,
  Text,
  Divider,
  Flex,
  Box,
  Heading,
  IconButton,
  Grid,
  GridItem,
  Button,
  Image,
} from "@chakra-ui/react";

import { FC, memo, useCallback, useContext, useState } from "react";
import "../../css/MobileDetailDialog.scss";
import { AiFillHeart } from "react-icons/ai";
import { motion } from "framer-motion";
import { LikeButtonFlagContext } from "../CreateContext";
import { HeightCalculation, WidthCalculation } from "../SizeCaluculation";
import { Apihost } from "../utils/Apihost";

type Props = {
  TopicID: number;
  WallLike: number;
  buttonColor: string;
  Size?: string;
  setLikeCount: React.Dispatch<React.SetStateAction<number>>;
  ModalLayout: number;
};

export const LikeButton: FC<Props> = memo((props) => {
  const { TopicID, WallLike, buttonColor, Size, setLikeCount, ModalLayout } =
    props;
  const { LikeFlag, setLikeFlag } = useContext(LikeButtonFlagContext);

  const [ButtonFlag, setButtonFlag] = useState(false);

  const apihost = Apihost("wall");

  let LikeButtonIcon = "small_like_button_icon";
  let LikeButtonIconLeft = "small_like_button_icon_left";
  let fontSize = `${WidthCalculation(20, 20)}px`;

  if (Size == "big") {
    LikeButtonIcon = "big_like_button_icon";
    LikeButtonIconLeft = "big_like_button_icon_left";
    fontSize = `${WidthCalculation(28, 28)}px`;
  }

  const MotionBox = motion(Box);

  const handleButtonClick = useCallback(() => {
    if (process.env.REACT_APP_OLD_API === "true") {
      fetch(`${apihost}/vote-topic`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "DONT_PANIC",
        },
        body: JSON.stringify({ TOPIC_ID: TopicID }),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.log("データの送信に失敗しました", error);
        });
    } else if (process.env.REACT_APP_OLD_API === "false") {
      fetch(`${apihost}/api/topic-media/vote-topic`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "DONT_PANIC",
        },
        body: JSON.stringify({ topic_id: TopicID }),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.log("データの送信に失敗しました", error);
        });
    }
    if (ModalLayout === 1) {
      if (!LikeFlag) {
        setLikeFlag(true);
      }
    }
    setLikeCount(WallLike + 1);
    setButtonFlag(true);
  }, [WallLike]);

  const floatingHeartsTransforms =
    Size == "big"
      ? [
          { x: 5, y: -22 }, //上
          { x: 15, y: -17 }, //右上
          { x: 24, y: -3 }, //右
          { x: 15, y: 17 }, //右下
          { x: 5, y: 22 }, //下
          { x: -8, y: 17 }, //左下
          { x: -18, y: -2 }, //左
          { x: -8, y: -17 }, //左上
        ]
      : [
          { x: -7, y: -22 }, //上
          { x: 3, y: -17 }, //右上
          { x: 12, y: -3 }, //右
          { x: 3, y: 17 }, //右下
          { x: -7, y: 22 }, //下
          { x: -20, y: 17 }, //左下
          { x: -30, y: -2 }, //左
          { x: -20, y: -17 }, //左上
        ];

  const variants = {
    visible: ({ x, y }: { x: number; y: number }) => ({
      opacity: [0.7, 0.4, 0.2, 0],
      x,
      y,
      transition: {
        type: "spring",
        stiffness: 133,
        damping: 45,
        mass: 1,
      },
    }),
    hidden: { opacity: 0 },
  };

  return (
    <MotionBox
      pl={Size == "big" ? `${window.innerWidth * 0.008}px` : "none"}
      bg={Size == "big" ? "rgba(250, 250, 250, 0.3)" : "tranceparent"}
      borderRadius="6px"
      borderWidth={Size == "big" ? "1px" : "none"}
      borderColor={Size == "big" ? "red.500" : "none"}
      display="flex"
      width={`${WidthCalculation(100, 100)}px`}
      className={`${LikeButtonIcon}`}
      aria-label="Like"
      justifyContent="center"
      alignItems="center"
      position="relative"
      onClick={(e) => {
        e.stopPropagation();
        handleButtonClick(); // handleButtonClick 関数を呼び出す
      }}
    >
      <AiFillHeart
        size={`${WidthCalculation(28, 28)}px`}
        color={`${buttonColor}`}
        className={`${LikeButtonIconLeft}`}
      />
      <MotionBox
        style={{ outline: "none" }}
        w={`${WidthCalculation(50, 50)}px`}
        display="flex"
        justifyContent="center"
        alignItems="center"
        initial={{ scale: 1 }}
        whileTap={{ scale: [1, 1.3, 1.6, 1.3, 1] }}
        transition={{ duration: 0.2 }}
      >
        <Text
          style={{ userSelect: "none" }}
          color="red.500"
          fontSize={`${fontSize}`}
        >
          {" "}
          {WallLike}
        </Text>
      </MotionBox>
      {ButtonFlag &&
        floatingHeartsTransforms.map((transform, index) => {
          const sizeChangeTranceform = {
            x: WidthCalculation(transform.x, transform.x),
            y: HeightCalculation(transform.y, transform.y),
          };
          return (
            <motion.svg
              key={index}
              style={{ position: "absolute", left: "20%" }}
              xmlns="http://www.w3.org/2000/svg"
              width={WidthCalculation(12, 12)}
              height={HeightCalculation(12, 12)}
              viewBox="0 0 24 24"
              fill="none"
              custom={sizeChangeTranceform}
              variants={variants}
              animate="visible"
            >
              <path
                d="M4.29995 5.6C2.49995 7.4 2.49995 10.2 4.29995 12L12 19.7L19.7 12C21.5 10.2 21.5 7.4 19.7 5.6C17.9 3.8 15.1 3.8 13.3 5.6L12 7L10.7 5.7C8.89995 3.9 6.09995 3.9 4.29995 5.6Z"
                stroke="#FF0266"
                fill="#FF0266"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </motion.svg>
          );
        })}
    </MotionBox>
  );
});
